import jsPDF from "jspdf";
import QRCode from "qrcode";
import autoTable from "jspdf-autotable";
import React from "react";
import {
  loadImageDimensions,
  urlToBase64,
  capitalizeFirstLetter,
} from "../modules/invoiceUtils";
import { usePermission } from "../../context/PermissionContext";
import uRLs from "../../utils/baseUtils";


export const generateIN_HA4_2PDF = async (
  data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings,
) => {
  const { documentConfig, isInterState } = invoiceConfig;
  const doc = new jsPDF("p", "mm", "a4");
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  const PADDING = 5;
  const HALF_PAGE_HEIGHT = 140; // Your target cut-off
  const USABLE_WIDTH = pageW - PADDING * 2; // Full width minus left/right padding
  const MARGIN_LEFT = PADDING;
  const MARGIN_RIGHT = pageW - PADDING;
  const centerX = pageW / 2;
  let y = PADDING; // Start at exactly 5mm from the top
  const checkHalfPageOverflow = (currentY, neededSpace = 10) => {
    if (currentY + neededSpace > HALF_PAGE_HEIGHT - PADDING) {
      doc.addPage();
      return PADDING; // Reset Y for new page
    }
    return currentY;
  };

  // const invoiceText =
  //   data.status === "CANCELLED" ? "CANCELLED" : documentConfig?.title;
  // doc.setFontSize(9);
  // doc.text(invoiceText, MARGIN_RIGHT, y + 2, { align: "right" });
  // if (documentConfig?.image) {
  //   try {
  //     const imagePath = documentConfig?.image;
  //     const logoBase64 = await urlToBase64(imagePath);
  //     const { width, height } = await loadImageDimensions(logoBase64);

  //     const maxWidth = 35;
  //     const maxHeight = 15;
  //     const ratio = Math.min(maxWidth / width, maxHeight / height);
  //     const finalW = width * ratio;
  //     const finalH = height * ratio;

  //     // --- CHANGE HERE: Set logoX to MARGIN_LEFT instead of centering it ---
  //     const logoX = MARGIN_LEFT;

  //     doc.addImage(logoBase64, "PNG", logoX, y, finalW, finalH);

  //     // We don't necessarily want to push y down for the whole page yet
  //     // so the text can stay aligned with the logo area
  //     const logoBottom = y + finalH;

  //     // 2. DISPLAY COMPANY NAME (Still Centered)
  //     doc.setFont("Inter-Bold", "bold");
  //     doc.setFontSize(10); // Slightly larger for company name
  //     doc.setTextColor(0);
  //     doc.text(documentConfig?.fromData?.title || "", centerX, y + 3, {
  //       align: "center",
  //     });

  //     // 3. DISPLAY ADDRESS (Still Centered)
  //     doc.setFont("Inter-Regular", "normal");
  //     doc.setFontSize(8);
  //     doc.setTextColor(60, 60, 60);

  //     const fromAddress = [
  //       [
  //         documentConfig?.fromData?.addressline1,
  //         documentConfig?.fromData?.addressline2,
  //         documentConfig?.fromData?.district,
  //         documentConfig?.fromData?.state,
  //         documentConfig?.fromData?.pincode,
  //       ]
  //         .filter(Boolean)
  //         .join(", "),
  //       [
  //        documentConfig?.fromData?.phone
  // ? `Ph: ${documentConfig.fromData.phone}${
  //     documentConfig?.fromData?.additionalPhone
  //       ? `, ${documentConfig.fromData.additionalPhone}`
  //       : ""
  //   }`
  // : documentConfig?.fromData?.additionalPhone
  //   ? `Ph: ${documentConfig.fromData.additionalPhone}`
  //   : "",
  //         documentConfig?.fromData?.gstnumber
  //           ? `GSTIN: ${documentConfig?.fromData.gstnumber}`
  //           : "",
  //       ]
  //         .filter(Boolean)
  //         .join(" | "),
  //     ].filter(Boolean);

  //     let addrY = y + 6;
  //     fromAddress.forEach((line) => {
  //       doc.text(line, centerX, addrY, { align: "center" });
  //       addrY += 4;
  //     });

  //     // Set y to the bottom of whichever is taller: the logo or the address text
  //     y = Math.max(logoBottom, addrY);
  //   } catch (e) {
  //     console.warn("Logo failed", e);
  //     y += 10; // Fallback spacing if logo fails
  //   }
  // }

  // y -= 2;

  // doc.setDrawColor(
  //   selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
  // );
  // doc.setLineWidth(0.3);
  // doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);
  // y += 3;
  // doc.setFontSize(7);
  // const invoiceLabel = documentConfig?.numberLabel;
  // const invoiceValue = `${documentConfig?.number || "-"}`;
  // const dateLabel = "  |  Date: ";
  // const dateValue = `${documentConfig?.Date?.date}`;

  // const dateValueW = doc.getTextWidth(dateValue);
  // const dateLabelW = doc.getTextWidth(dateLabel);
  // const invoiceValueW = doc.getTextWidth(invoiceValue);
  // const invoiceLabelW = doc.getTextWidth(invoiceLabel);

  // const totalWidth = invoiceLabelW + invoiceValueW + dateLabelW + dateValueW;

  // let currentX = MARGIN_RIGHT - totalWidth;
  // doc.setFont("Inter-Regular", "normal");
  // doc.text(invoiceLabel, currentX, y);
  // currentX += invoiceLabelW;

  // doc.setFont("Inter-Bold", "bold");
  // doc.text(invoiceValue, currentX, y);
  // currentX += invoiceValueW;

  // doc.setFont("Inter-Regular", "normal");
  // doc.text(dateLabel, currentX, y);
  // currentX += dateLabelW;

  // doc.setFont("Inter-Bold", "bold");
  // doc.text(dateValue, currentX, y);

  // y += 2;
  const invoiceText =
    data.status === "CANCELLED"
      ? "CANCELLED"
      : documentConfig?.title || "";

  // ---------- DOCUMENT TITLE ----------
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(9);
  doc.setTextColor(0);

  doc.text(
    invoiceText,
    MARGIN_RIGHT,
    y + 2,
    { align: "right" }
  );

  let logoHeight = 15;

  if (documentConfig?.image) {
    try {
      const imagePath = documentConfig.image;

      const logoBase64 = await urlToBase64(imagePath);

      const { width, height } =
        await loadImageDimensions(logoBase64);

      const maxWidth = 35;
      const maxHeight = 15;

      const ratio = Math.min(
        maxWidth / width,
        maxHeight / height
      );

      const finalW = width * ratio;
      const finalH = height * ratio;

      doc.addImage(
        logoBase64,
        "PNG",
        MARGIN_LEFT,
        y,
        finalW,
        finalH
      );

      logoHeight = finalH;
    } catch (e) {
      console.warn("Logo failed", e);

      // Keep reserved header height
      logoHeight = 15;
    }
  }
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0);
  // ---------- STORE NAME ----------
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0);

  doc.text(
    documentConfig?.fromData?.title?.toUpperCase() || "",
    centerX,
    y + 3,
    {
      align: "center",
    }
  );

  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(8);
  doc.setTextColor(60, 60, 60);

  // ---------- ADDRESS ----------
  const addressLine = [
    documentConfig?.fromData?.addressline1,
    documentConfig?.fromData?.addressline2,
    documentConfig?.fromData?.district,
    documentConfig?.fromData?.state,
    documentConfig?.fromData?.pincode,
  ]
    .filter(Boolean)
    .join(", ");

  // ---------- PHONE ----------
  const phoneParts = [
    documentConfig?.fromData?.phone,
    documentConfig?.fromData?.additionalPhone,
  ].filter(Boolean);

  const phoneText = phoneParts.length
    ? `Ph: ${phoneParts.join(", ")}`
    : "";
  const emailText = documentConfig?.fromData?.email
    ? `Email: ${documentConfig.fromData.email}`
    : "";
  let addrY = y + 7;
  if (addressLine) {
    doc.text(addressLine, centerX, addrY, {
      align: "center",
    });

    addrY += 3.5;
  }
  const contactLine = [
    phoneText,
    emailText,
  ]
    .filter(Boolean)
    .join(" | ");

  if (contactLine) {
    doc.text(contactLine, centerX, addrY, {
      align: "center",
    });

    addrY += 3.5;
  }

  // ---------- HEADER BOTTOM ----------
  const logoBottom = documentConfig?.image
    ? y + logoHeight
    : y;

  const detailsBottom = addrY;

  y = Math.max(logoBottom, detailsBottom) ;

  doc.setDrawColor(
    selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
  );
  doc.setLineWidth(0.3);

  doc.line(
    MARGIN_LEFT,
    y,
    MARGIN_RIGHT,
    y
  );

  y += 3;
  doc.setFontSize(7);

  const invoiceLabel =
    documentConfig?.numberLabel || "";

  const invoiceValue =
    `${documentConfig?.number || "-"}`;

  const dateLabel = "  |  Date: ";

  const dateValue =
    `${documentConfig?.Date?.date || ""}`;

  // IMPORTANT:
  // Set fonts before calculating widths.

  doc.setFont("Inter-Regular", "normal");

  const invoiceLabelW =
    doc.getTextWidth(invoiceLabel);

  const dateLabelW =
    doc.getTextWidth(dateLabel);

  doc.setFont("Inter-Bold", "bold");

  const invoiceValueW =
    doc.getTextWidth(invoiceValue);

  const dateValueW =
    doc.getTextWidth(dateValue);

  const totalWidth =
    invoiceLabelW +
    invoiceValueW +
    dateLabelW +
    dateValueW;

  let currentX =
    MARGIN_RIGHT - totalWidth;

  // Invoice label
  doc.setFont("Inter-Regular", "normal");

  doc.text(
    invoiceLabel,
    currentX,
    y
  );

  currentX += invoiceLabelW;

  // Invoice number
  doc.setFont("Inter-Bold", "bold");
  doc.text(
    invoiceValue,
    currentX,
    y
  );

  currentX += invoiceValueW;

  // Date label
  doc.setFont("Inter-Regular", "normal");

  doc.text(
    dateLabel,
    currentX,
    y
  );

  currentX += dateLabelW;

  // Date
  doc.setFont("Inter-Bold", "bold");

  doc.text(
    dateValue,
    currentX,
    y
  );

  y += 2;
  const toDetailsLine = [
    documentConfig?.toData?.name || "-",
    [
      documentConfig?.toData?.addressline1,
      documentConfig?.toData?.addressline2,
      documentConfig?.toData?.district,
      documentConfig?.toData?.state,
      documentConfig?.toData?.pincode,
    ],
    [
      documentConfig?.toData?.gstnumber
        ? `GSTIN: ${documentConfig?.toData.gstnumber}`
        : "",
      documentConfig?.toData?.phone
        ? `Mobile: ${documentConfig?.toData.phone}`
        : "",
      documentConfig?.toData?.referenceid
        ? `Reference No: ${documentConfig?.toData.referenceid}`
        : "",
      documentConfig?.toData?.fssai
        ? `FASSI: ${documentConfig?.toData.fssai}`
        : "",
      documentConfig?.toData?.cinnumber
        ? `CIN: ${documentConfig?.toData.cinnumber}`
        : "",
      documentConfig?.toData?.pannumber
        ? `PAN: ${documentConfig?.toData.pannumber}`
        : "",
    ]
      .filter(Boolean)
      .join(" | "),
  ]
    .filter(Boolean)
    .join("\n");

  // y += 2;
  const colWidth = pageW - PADDING * 2;
  if (documentConfig?.toData) {
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text(documentConfig?.toLabel, PADDING, y);
    const wrappedBilling = doc.splitTextToSize(toDetailsLine, colWidth - 5);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    doc.text(wrappedBilling, PADDING, y + 4);

    const billingHeight = wrappedBilling.length * 3.5;
    y += Math.max(billingHeight) + 2;
  }

  const leftBoxX = 8;

  /* -------------------------------------------------
     PRODUCT TABLE1
  ------------------------------------------------- */
  autoTable(doc, {
    startY: y + 1,
    theme: "plain",
    rowPageBreak: "avoid",

    margin: {
      top: PADDING,
      left: PADDING,
      right: PADDING,
      bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
    },
    pageBreak: "auto",
    styles: {
      font: "Inter-Regular",
      fontSize: 7.5,
      cellPadding: { top: 1, right: 1, bottom: 1, left: 1 },
      valign: "middle",
      lineWidth: 0,
      lineColor: selectedTheme?.templateTheme?.borderColor,
      textColor: [0, 0, 0],
    },
    headStyles: {
      font: "Inter-Bold",
      fontSize: 8,
      fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100],
      textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0],
      lineWidth: { top: 0.5, bottom: 0.5 },
      lineColor: selectedTheme?.templateTheme?.borderColor,
    },
    head: [
      ["#", "Item", "MRP", "Selling Price", "Qty", "Landing Cost", "Amount"],
    ],
    body: documentConfig?.items.map((it, i) => {
      const itemDesc = it.hsnsac ? `${it.title}\nHSN: ${it.hsnsac}` : it.title;
      return [
        i + 1,
        itemDesc,
        `${it.mrp}`,
        `${it.baseprice}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`, //Pcs
        `${it.lineTotalLandingCost}`,
        `${it.lineGrandTotal}`,
      ];
    }),
    columnStyles: {
      0: { cellWidth: 13, halign: "center" }, // S.No
      1: { cellWidth: "auto", halign: "left" }, // Flexible Description
      2: { cellWidth: 25, halign: "right" }, // Right-aligned Price
      3: { cellWidth: 25, halign: "right" },
      4: { cellWidth: 15, halign: "center" }, // Right-aligned Price
      5: { cellWidth: 25, halign: "right" },
      6: { cellWidth: 25, halign: "right" },
    },
    didParseCell: function (data) {
      if (data?.section === "head") {
        data.cell.styles.lineWidth = { top: 0.2, bottom: 0.2 };
        const colId = data.column.index;
        if ([0,1,2, 3,4,5,6].includes(colId)) {
          data.cell.styles.halign = "center";
        }

        if (data.column.index === 0) {
          data.cell.styles.lineWidth = {
            ...data.cell.styles.lineWidth,
            left: 0.2,
          };
        }

        if (data.column.index === 6) {
          data.cell.styles.lineWidth = {
            ...data.cell.styles.lineWidth,
            right: 0.2,
          };
        }
      }
      if (data.section === "body") {
        const colId = data.column.index;
        let lines = { bottom: 0 };

        if (colId === 0) {
          lines.left = 0.1;
        }

        if (colId === 6) {
          lines.right = 0.1;
        }
        data.cell.styles.lineWidth = lines;
      }
    },

    didDrawPage: function (data) {
      const finalY = data.cursor.y;
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
      doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
    },
  });

  /* -------------------------------------------------
//    TOTALS & GST SECTION (Split Row)
// ------------------------------------------------- */

  y = doc.lastAutoTable.finalY;
  // y = checkHalfPageOverflow(y, 35);

  const summaryData = [
    ["Total Amount Before Tax", `${documentConfig?.totalBasePrice}`],
  ];
  if (isInterState) {
    summaryData.push(["IGST ", `${documentConfig?.igstAmount}`]);
  } else {
    summaryData.push(["CGST ", `${documentConfig?.cgstAmount}`]);
    summaryData.push(["SGST ", `${documentConfig?.sgstAmount}`]);
  }

  const sectionStartY = y;
  const boxTop = y;
  const totalTextX = 140;
  const verticalDividerX = totalTextX - 5;

  doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
  doc.setLineWidth(0.1);
  doc.line(PADDING, boxTop, MARGIN_RIGHT, boxTop);

  let rightY = sectionStartY + 5;
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.text("Total", totalTextX, rightY);
  doc.text(`${documentConfig?.grandTotal}`, MARGIN_RIGHT - 2, rightY, {
    align: "right",
  });

  rightY += 2;
  doc.line(totalTextX, rightY, MARGIN_RIGHT, rightY);

  rightY += 5;
  doc.setFontSize(9);
  doc.setTextColor(48, 48, 48);
  doc.setFont("Inter-Regular", "normal");
  summaryData.forEach(([label, value], index) => {
    doc.text(label, totalTextX, rightY);
    doc.text(value, MARGIN_RIGHT - 2, rightY, { align: "right" });
    rightY += index === summaryData.length - 1 ? 0 : 4;
  });

  // // --- LEFT SIDE: IN WORDS ---
  let leftY = sectionStartY + 5;
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0);

  const labelStr = "IN WORDS : ";
  const fullAmountStr = `${labelStr}${documentConfig?.amountInWords || ""}`;
  const leftColumnWidth = verticalDividerX - PADDING - 6;

  const leftWrappedWords = doc.splitTextToSize(fullAmountStr, leftColumnWidth);

  leftWrappedWords.forEach((line, index) => {
    doc.text(line, PADDING + 2, leftY + index * 4);
  });
  leftY += leftWrappedWords.length * 4 + 3;
  if (
    documentConfig?.bankDetails 
  ) {
    const bankStartY = leftY;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("Bank Details:", PADDING + 2, bankStartY);

   const bankInfo =[
      ["Account #:", documentConfig?.bankDetails?.accountNo || ""],
      ["IFSC:", documentConfig?.bankDetails?.ifsc || ""],
      ["Name:", documentConfig?.bankDetails?.beneficiaryName || ""],
      ["Bank Name:", documentConfig?.bankDetails?.bankName || ""],
      ["Branch Name:", documentConfig?.bankDetails?.branch || ""],      
    ].filter(([_, value]) => Boolean(value));

    let currentBankY = bankStartY + 4;
    bankInfo.forEach(([label, value]) => {
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0, 0, 0);
      doc.text(label, PADDING + 2, currentBankY);

      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.text(String(value || ""), PADDING + 25, currentBankY);

      currentBankY += 3.8;
    });

    // Generate & Draw QR Code alongside Bank Details
    const upiId = storeSettings?.paymentSettings?.upiId;
    const beneficiaryName =
      storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "";

    if (upiId) {
      try {
        const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(beneficiaryName)}&cu=INR`;
        const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
          errorCorrectionLevel: "L",
          margin: 1,
          scale: 4,
        });

        const qrSize = 18;
        const qrX = verticalDividerX - qrSize - 4; // Positioned before vertical line
        const qrY = bankStartY + 1;

        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      } catch (err) {
        console.warn("QR Code generation failed", err);
      }
    }

    leftY = currentBankY;
  }
  const minBoxHeight =
    documentConfig?.bankDetails 
      ? 33
      : 25;
  const leftSectionEndY = sectionStartY + minBoxHeight;
  const finalBoxBottom = Math.max(rightY, leftSectionEndY);

  doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
  doc.line(PADDING, boxTop, PADDING, finalBoxBottom);
  doc.line(MARGIN_RIGHT, boxTop, MARGIN_RIGHT, finalBoxBottom);
  doc.line(PADDING, finalBoxBottom, MARGIN_RIGHT, finalBoxBottom);
  doc.line(verticalDividerX, boxTop, verticalDividerX, finalBoxBottom);

  y = finalBoxBottom + 2;

  // REMARK SECTION
  // =====================================================
  if (documentConfig?.remarks?.trim()) {
    y += 4;
    const remarkWidth = pageW - PADDING * 2;
    const lineHeight = 3.5;
    const remarkLines = doc.splitTextToSize(
      capitalizeFirstLetter(documentConfig.remarks),
      remarkWidth - 6,
    );
    const remarkHeight = remarkLines.length * lineHeight + 4;
    if (y + remarkHeight > HALF_PAGE_HEIGHT - 12) {
      doc.addPage();
      y = PADDING + 5;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("Remark", PADDING, y);
    y += 2;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    // Move to next page if needed

    doc.setDrawColor(
      selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
    );
    doc.setLineWidth(0.2);

    let textY = y + 2;

    remarkLines.forEach((line) => {
      doc.text(line, PADDING, textY);
      textY += lineHeight;
    });

    y += remarkHeight;
  }

  if (storeSettings?.invoiceSettings?.signature) {
    const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
    try {
      const base64 = await urlToBase64(signimg);
      const { width, height } = await loadImageDimensions(base64);

      const maxWidth = 30;
      const maxHeight = 12;
      const ratio = Math.min(maxWidth / width, maxHeight / height);
      const imgW = width * ratio;
      const imgH = height * ratio;

      // Draw image aligned to the right
      doc.addImage(
        base64,
        signimg.endsWith(".png") ? "PNG" : "JPEG",
        MARGIN_RIGHT - imgW,
        y,
        imgW,
        imgH,
      );

      y += imgH + 2;
    } catch (e) {
      console.warn("Signature load failed", e);
      y += 8;
    }
  } else {
    y += 4; // Leave spacing if no image
  }

  // Authorised Signature Text
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text("Authorised Signature", MARGIN_RIGHT, y, {
    align: "right",
  });

  y += 4;
  // if (data?.negobillBranding) {
  //   // const minGapY = y + 5;
  //   // const bottomLimitY = HALF_PAGE_HEIGHT - 5;
  //   // let finalBrandingY = Math.max(minGapY, bottomLimitY);
  //     const finalBrandingY = y + 3;

  //   const normalText = "Powered by ";
  //   const boldText = "NegoBill.com";
  //   doc.setFontSize(8);
  //   // doc.setTextColor(100, 100, 100);
  //   doc.setFont("Inter-Regular", "normal");
  //   const normalW = doc.getTextWidth(normalText);
  //   doc.text(normalText, MARGIN_LEFT, finalBrandingY);
  //   doc.setFont("Inter-Bold", "bold");
  //   doc.text(boldText, MARGIN_LEFT + normalW, finalBrandingY);
  // }
  if (storeSettings?.negobillBranding) {
    const y = HALF_PAGE_HEIGHT - 5;

    const normalText = "Powered by ";
    const boldText = "NegoBill.com";
    doc.setFontSize(8);

    doc.setFont("Inter-Bold", "bold");
    const boldW = doc.getTextWidth(boldText);

    doc.text(boldText, PADDING + boldW - 2, y, {
      align: "left",
    });
    doc.setFont("Inter-Regular", "normal");
    doc.text(normalText, MARGIN_LEFT, y, {
      align: "left",
    });
  }

  return doc;
};

export const generateBILL_HA4_2PDF = async (
  data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings,
) => {
  const { documentConfig, isPreSale,  } = invoiceConfig;
  const doc = new jsPDF("p", "mm", "a4");
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  const PADDING = 5;
  const HALF_PAGE_HEIGHT = 140; // Your target cut-off
  const USABLE_WIDTH = pageW - PADDING * 2; // Full width minus left/right padding
  const MARGIN_LEFT = PADDING;
  const MARGIN_RIGHT = pageW - PADDING;
  const centerX = pageW / 2;
  let y = PADDING; // Start at exactly 5mm from the top

  const invoiceText =
    data.status === "CANCELLED" ? "CANCELLED" : documentConfig?.title;
  doc.setFontSize(9);
  doc.text(invoiceText, MARGIN_RIGHT, y + 2, { align: "right" });
 let logoHeight = 15;

if (documentConfig?.image) {
  try {
    const imagePath = documentConfig.image;

    const logoBase64 = await urlToBase64(imagePath);

    const { width, height } =
      await loadImageDimensions(logoBase64);

    const maxWidth = 35;
    const maxHeight = 15;

    const ratio = Math.min(
      maxWidth / width,
      maxHeight / height
    );

    const finalW = width * ratio;
    const finalH = height * ratio;

    doc.addImage(
      logoBase64,
      "PNG",
      MARGIN_LEFT,
      y,
      finalW,
      finalH
    );

    logoHeight = finalH;
  } catch (e) {
    console.warn("Logo failed", e);

    // Keep reserved header height
    logoHeight = 15;
  }
}

doc.setFont("Inter-Bold", "bold");
doc.setFontSize(10);
doc.setTextColor(0);
// ---------- STORE NAME ----------
doc.setFont("Inter-Bold", "bold");
doc.setFontSize(10);
doc.setTextColor(0);

doc.text(
  documentConfig?.fromData?.title?.toUpperCase() || "",
  centerX,
  y + 3,
  {
    align: "center",
  }
);

doc.setFont("Inter-Regular", "normal");
doc.setFontSize(8);
doc.setTextColor(60, 60, 60);

// ---------- ADDRESS ----------
const addressLine = [
  documentConfig?.fromData?.addressline1,
  documentConfig?.fromData?.addressline2,
  documentConfig?.fromData?.district,
  documentConfig?.fromData?.state,
  documentConfig?.fromData?.pincode,
]
  .filter(Boolean)
  .join(", ");

// ---------- PHONE ----------
const phoneParts = [
  documentConfig?.fromData?.phone,
  documentConfig?.fromData?.additionalPhone,
].filter(Boolean);

const phoneText = phoneParts.length
  ? `Ph: ${phoneParts.join(", ")}`
  : "";
const emailText = documentConfig?.fromData?.email
  ? `Email: ${documentConfig.fromData.email}`
  : "";
let addrY = y + 7;
if (addressLine) {
  doc.text(addressLine, centerX, addrY, {
    align: "center",
  });

  addrY += 3.5;
}
const contactLine = [
  phoneText,
  emailText,
]
  .filter(Boolean)
  .join(" | ");

if (contactLine) {
  doc.text(contactLine, centerX, addrY, {
    align: "center",
  });

  addrY += 3.5;
}

// ---------- HEADER BOTTOM ----------
const logoBottom = documentConfig?.image
  ? y + logoHeight
  : y;

const detailsBottom = addrY;

y = Math.max(logoBottom, detailsBottom) ;

doc.setDrawColor(
  selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
);
doc.setLineWidth(0.3);

doc.line(
  MARGIN_LEFT,
  y,
  MARGIN_RIGHT,
  y
);

y += 3;
doc.setFontSize(7);

const invoiceLabel =
  documentConfig?.numberLabel || "";

const invoiceValue =
  `${documentConfig?.number || "-"}`;

const dateLabel = "  |  Date: ";

const dateValue =
  `${documentConfig?.Date?.date || ""}`;

// IMPORTANT:
// Set fonts before calculating widths.

doc.setFont("Inter-Regular", "normal");

const invoiceLabelW =
  doc.getTextWidth(invoiceLabel);

const dateLabelW =
  doc.getTextWidth(dateLabel);

doc.setFont("Inter-Bold", "bold");

const invoiceValueW =
  doc.getTextWidth(invoiceValue);

const dateValueW =
  doc.getTextWidth(dateValue);

const totalWidth =
  invoiceLabelW +
  invoiceValueW +
  dateLabelW +
  dateValueW;

let currentX =
  MARGIN_RIGHT - totalWidth;

// Invoice label
doc.setFont("Inter-Regular", "normal");

doc.text(
  invoiceLabel,
  currentX,
  y
);

currentX += invoiceLabelW;

// Invoice number
doc.setFont("Inter-Bold", "bold");
doc.text(
  invoiceValue,
  currentX,
  y
);

currentX += invoiceValueW;

// Date label
doc.setFont("Inter-Regular", "normal");

doc.text(
  dateLabel,
  currentX,
  y
);

currentX += dateLabelW;

// Date
doc.setFont("Inter-Bold", "bold");

doc.text(
  dateValue,
  currentX,
  y
);

y += 2;

  const toDetailsLine = [
    documentConfig?.toData?.name || "-",
    [
      documentConfig?.toData?.addressline1,
      documentConfig?.toData?.addressline2,
      documentConfig?.toData?.district,
      //documentConfig?.toData?.state,
      documentConfig?.toData?.pincode,
    ],
    [
      documentConfig?.toData?.gstnumber
        ? `GSTIN: ${documentConfig?.toData.gstnumber}`
        : "",
      documentConfig?.toData?.phone
        ? `Mobile: ${documentConfig?.toData.phone}`
        : "",
      documentConfig?.toData?.referenceid
        ? `Reference No: ${documentConfig?.toData.referenceid}`
        : "",
      documentConfig?.toData?.fssai
        ? `FASSI: ${documentConfig?.toData.fssai}`
        : "",
      documentConfig?.toData?.cinnumber
        ? `CIN: ${documentConfig?.toData.cinnumber}`
        : "",
      documentConfig?.toData?.pannumber
        ? `PAN: ${documentConfig?.toData.pannumber}`
        : "",
    ]
      .filter(Boolean)
      .join(" | "),
  ]
    .filter(Boolean)
    .join("\n");

  // y += 2;
  const colWidth = pageW - PADDING * 2;
  if (documentConfig?.toData) {
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text(documentConfig?.toLabel, PADDING, y);
    const wrappedBilling = doc.splitTextToSize(toDetailsLine, colWidth - 5);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    doc.text(wrappedBilling, PADDING, y + 4);

    const billingHeight = wrappedBilling.length * 3.5;
    y += Math.max(billingHeight) + 2;
  }

  const leftBoxX = 8;

  /* -------------------------------------------------
     PRODUCT TABLE1
  ------------------------------------------------- */
  autoTable(doc, {
    startY: y + 1,
    theme: "plain",
    rowPageBreak: "avoid",

    margin: {
      top: PADDING,
      left: PADDING,
      right: PADDING,
      bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
    },
    pageBreak: "auto",
    styles: {
      font: "Inter-Regular",
      fontSize: 7.5,
      cellPadding: { top: 1, right: 1, bottom: 1, left: 1 },
      valign: "middle",
      lineWidth: 0,
      lineColor: selectedTheme?.templateTheme?.borderColor,
      textColor: [0, 0, 0],
    },
    headStyles: {
      font: "Inter-Bold",
      fontSize: 8,
      fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100],
      textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0],
      lineWidth: { top: 0.5, bottom: 0.5 },
      lineColor: selectedTheme?.templateTheme?.borderColor,
    },
    head: [["#", "Item", "MRP", "Selling Price", "Qty", "Amount"]],
    body: documentConfig?.items.map((it, i) => {
      const itemDesc = it.hsnsac ? `${it.title}\nHSN: ${it.hsnsac}` : it.title;
      return [
        i + 1,
        itemDesc,
        `${it.mrp}`,
        `${it.baseprice}`,
        `${it.quantity} ${(() => {
          const unitCode = it?.isSecondaryUnit
            ? it?.unitConfig?.secondaryUnitCode
            : it?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`, //Pcs
        `${it.lineGrandTotal}`,
      ];
    }),
    columnStyles: {
      0: { cellWidth: 13, halign: "center" }, // S.No
      1: { cellWidth: "auto", halign: "left" }, // Flexible Description
      2: { cellWidth: 25, halign: "right" }, // Right-aligned Price
      3: { cellWidth: 25, halign: "right" },
      4: { cellWidth: 15, halign: "right" }, // Right-aligned Price
      5: { cellWidth: 25, halign: "right" }, // Amount
    },
    didParseCell: function (data) {
      if (data.section === "head") {
        data.cell.styles.lineWidth = { top: 0.2, bottom: 0.2 };
        const colId = data.column.index;
         if ([0,1,2, 3,4,5].includes(colId)) {
          data.cell.styles.halign = "center";
        }

        if (data.column.index === 0) {
          data.cell.styles.lineWidth = {
            ...data.cell.styles.lineWidth,
            left: 0.2,
          };
        }

        if (data.column.index === 5) {
          data.cell.styles.lineWidth = {
            ...data.cell.styles.lineWidth,
            right: 0.2,
          };
        }
      }
      if (data.section === "body") {
        const colId = data.column.index;
        let lines = { bottom: 0 };

        if (colId === 0) {
          lines.left = 0.1;
        }

        if (colId === 5) {
          lines.right = 0.1;
        }
        data.cell.styles.lineWidth = lines;
      }
    },

    didDrawPage: function (data) {
      const finalY = data.cursor.y;
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
      doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
    },
  });

  /* -------------------------------------------------
//    TOTALS & GST SECTION (Split Row)
// ------------------------------------------------- */

  y = doc.lastAutoTable.finalY;
  // y = checkHalfPageOverflow(y, 35);

  //  const summaryData = [
  //     ["Total Amount Before Tax",  formatCurrency((CurrencyConverter.toCurrency(data.totalbaseprice|| 0, "INR")), "INR", true, true)]];
  //   if (isInterState) {
  //     summaryData.push(["IGST ", formatCurrency((CurrencyConverter.toCurrency(data.igstamount|| 0, "INR")), "INR", true, true)]);
  //     } else {
  //     summaryData.push(["CGST ", formatCurrency((CurrencyConverter.toCurrency(data.cgstamount|| 0, "INR")), "INR", true, true)]);
  //     summaryData.push(["SGST ",  formatCurrency((CurrencyConverter.toCurrency(data.sgstamount|| 0, "INR")), "INR", true, true)]);
  //     }

  const sectionStartY = y;
  const boxTop = y;
  const totalTextX = 140;
  const verticalDividerX = totalTextX - 5;

  doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
  doc.setLineWidth(0.1);
  doc.line(PADDING, boxTop, MARGIN_RIGHT, boxTop);

  let rightY = sectionStartY + 5;
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(10);
  doc.setTextColor(0);
  doc.text("Total", totalTextX, rightY);
  doc.text(`${documentConfig?.grandTotal}`, MARGIN_RIGHT - 2, rightY, {
    align: "right",
  });

  rightY += 2;
  doc.line(totalTextX, rightY, MARGIN_RIGHT, rightY);

  // rightY += 5;
  // doc.setFontSize(9);
  // doc.setTextColor(48, 48, 48);

  // summaryData.forEach(([label, value], index) => {
  //     doc.text(label, totalTextX, rightY);
  //     doc.text(value, MARGIN_RIGHT - 2, rightY, { align: "right" });
  //     rightY += (index === summaryData.length - 1) ? 0 : 4;
  // });

  // // --- LEFT SIDE: IN WORDS ---
  let leftY = sectionStartY + 5;
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0);

  const labelStr = "IN WORDS : ";
  const fullAmountStr = `${labelStr}${documentConfig?.amountInWords || ""}`;
  const leftColumnWidth = verticalDividerX - PADDING - 6;

  const leftWrappedWords = doc.splitTextToSize(fullAmountStr, leftColumnWidth);

  leftWrappedWords.forEach((line, index) => {
    doc.text(line, PADDING + 2, leftY + index * 4);
  });
  leftY += leftWrappedWords.length * 4 + 3;
  if (
    documentConfig?.bankDetails 
  ) {
    const bankStartY = leftY;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("Bank Details:", PADDING + 2, bankStartY);

   const bankInfo =[
      ["Account #:", documentConfig?.bankDetails?.accountNo || ""],
      ["IFSC:", documentConfig?.bankDetails?.ifsc || ""],
      ["Name:", documentConfig?.bankDetails?.beneficiaryName || ""],
      ["Bank Name:", documentConfig?.bankDetails?.bankName || ""],
      ["Branch Name:", documentConfig?.bankDetails?.branch || ""],      
    ].filter(([_, value]) => Boolean(value));

    let currentBankY = bankStartY + 4;
    bankInfo.forEach(([label, value]) => {
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0, 0, 0);
      doc.text(label, PADDING + 2, currentBankY);

      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.text(String(value || ""), PADDING + 25, currentBankY);

      currentBankY += 3.8;
    });

    // Generate & Draw QR Code alongside Bank Details
    const upiId = storeSettings?.paymentSettings?.upiId;
    const beneficiaryName =
      storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "";

    if (upiId) {
      try {
        const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(beneficiaryName)}&cu=INR`;
        const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
          errorCorrectionLevel: "L",
          margin: 1,
          scale: 4,
        });

        const qrSize = 18;
        const qrX = verticalDividerX - qrSize - 4; // Positioned before vertical line
        const qrY = bankStartY + 1;

        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      } catch (err) {
        console.warn("QR Code generation failed", err);
      }
    }

    leftY = currentBankY;
  }
  const minBoxHeight =
    documentConfig?.bankDetails 
      ? 33
      : 15;
  // const authSignatoryY = sectionStartY + minBoxHeight - 4;

  // if (data.storeSettings?.invoiceSettings?.signature) {
  //   try {
  //     const signimg = data?.signimg;
  //     const base64 = await urlToBase64(signimg);
  //     const { width, height } = await loadImageDimensions(base64);

  //     const maxWidth = 30;
  //     const maxHeight = 12;
  //     const ratio = Math.min(maxWidth / width, maxHeight / height);
  //     const imgW = width * ratio;
  //     const imgH = height * ratio;

  //     // Position it right above the text
  //     doc.addImage(
  //       base64,
  //       signimg.endsWith(".png") ? "PNG" : "JPEG",
  //       PADDING + 2,
  //       authSignatoryY - imgH - 3,
  //       imgW,
  //       imgH,
  //     );
  //   } catch (e) {
  //     console.warn("Signature load failed", e);
  //   }
  // }

  // doc.setFont("Inter-Regular", "normal");
  // doc.setFontSize(9);
  // doc.setTextColor(0);
  // doc.text("Authorized Signatory", PADDING + 2, authSignatoryY, {
  //   align: "left",
  // });

  const leftSectionEndY = sectionStartY + minBoxHeight;
  const finalBoxBottom = Math.max(rightY, leftSectionEndY);

  doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || "#c8c8c8");
  doc.line(PADDING, boxTop, PADDING, finalBoxBottom);
  doc.line(MARGIN_RIGHT, boxTop, MARGIN_RIGHT, finalBoxBottom);
  doc.line(PADDING, finalBoxBottom, MARGIN_RIGHT, finalBoxBottom);
  doc.line(verticalDividerX, boxTop, verticalDividerX, finalBoxBottom);

  y = finalBoxBottom + 2;
  if (documentConfig?.remarks?.trim()) {
    y += 4;
    const remarkWidth = pageW - PADDING * 2;
    const remarkLines = doc.splitTextToSize(
      capitalizeFirstLetter(documentConfig.remarks),
      remarkWidth - 6,
    );

    const lineHeight = 3.5;
    const remarkHeight = remarkLines.length * lineHeight + 4;

    // Move to next page if needed
    if (y + remarkHeight > HALF_PAGE_HEIGHT - 12) {
      doc.addPage();
      y = PADDING + 5;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("Remark", PADDING, y);
    y += 2;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);

    doc.setDrawColor(
      selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
    );
    doc.setLineWidth(0.2);

    let textY = y + 2;

    remarkLines.forEach((line) => {
      doc.text(line, PADDING, textY);
      textY += lineHeight;
    });

    y += remarkHeight;
  }
  if (storeSettings.invoiceSettings.signature) {
    try {
      const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;

      const base64 = await urlToBase64(signimg);
      const { width, height } = await loadImageDimensions(base64);

      const maxWidth = 30;
      const maxHeight = 12;
      const ratio = Math.min(maxWidth / width, maxHeight / height);
      const imgW = width * ratio;
      const imgH = height * ratio;

      // Draw image aligned to the right
      doc.addImage(
        base64,
        signimg.endsWith(".png") ? "PNG" : "JPEG",
        MARGIN_RIGHT - imgW,
        y,
        imgW,
        imgH,
      );

      y += imgH + 2;
    } catch (e) {
      console.warn("Signature load failed", e);
      y += 8;
    }
  } else {
    y += 4; // Leave spacing if no image
  }

  // Authorised Signature Text
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text("Authorised Signature", MARGIN_RIGHT, y, {
    align: "right",
  });

  y += 4;
  if (storeSettings?.negobillBranding) {
    const y = HALF_PAGE_HEIGHT - 5;

    const normalText = "Powered by ";
    const boldText = "NegoBill.com";
    doc.setFontSize(8);

    doc.setFont("Inter-Bold", "bold");
    const boldW = doc.getTextWidth(boldText);

    doc.text(boldText, PADDING + boldW - 2, y, {
      align: "left",
    });
    doc.setFont("Inter-Regular", "normal");
    doc.text(normalText, MARGIN_LEFT, y, {
      align: "left",
    });
  }

  return doc;
};
const StandardReceipt = ({
  data,
  qrCodeDataUrl,
  selectedTheme,  
  invoiceConfig,
}) => {
  const {
    documentConfig,    
    showBillDetails,
    isPreSale,
    showTaxDetails,
    isInterState,
  } = invoiceConfig;

  const { storeSettings } = usePermission();
 
  return (
    <>
      {showTaxDetails ? (
        <div className="tm_container">
          <div className="tm_invoice_wrap">
            <div className="tm_invoice tm_style1 tm_type1">
              <div className="tm_invoice_in p-2">
                <div
                  className="pdfcontent"
                  style={{
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      //  alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div style={{ flex: "1", textAlign: "left" }}>
                      {documentConfig?.image && (
                        <img
                          src={documentConfig?.image}
                          className="img-rounded logo"
                          height="30"
                          alt="Logo"
                        />
                      )}
                    </div>

                    <div
                      style={{
                        //  flex: "1",
                        textAlign: "center",
                        lineHeight: "16px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "700",
                          fontSize: "12px",
                          textTransform: "uppercase",
                        }}
                      >
                        {documentConfig?.fromData?.title}
                      </div>
                      <div clasName="font-10">
                        {documentConfig?.fromData?.addressline1 || ""}{" "}
                        {documentConfig?.fromData?.addressline2 || ""}{" "}
                        {documentConfig?.fromData?.district || ""}{" "}
                        {documentConfig?.fromData?.country || ""} {" "}
                        {documentConfig?.fromData?.pincode || ""}
                      </div>
                      <div style={{ fontSize: "10px" }}>
                        Ph:  {documentConfig?.fromData?.phone || ""}
                            {documentConfig?.fromData?.additionalPhone && (
                              <>, {documentConfig.fromData.additionalPhone}</>
                            )}{" "}
                        {documentConfig?.fromData?.email &&
                          `| Email: ${documentConfig?.fromData?.email}`}
                      </div>
                    </div>

                    <div style={{ flex: "1", textAlign: "right" }}>
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "14px",
                          textTransform: "uppercase",
                        }}
                      >
                        {documentConfig?.title && <>{documentConfig?.title}</>}
                      </div>
                      {data?.status === "CANCELLED" && (
                        <div
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          {data?.status}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {documentConfig?.toData && (
                    <div className="col-8 pe-1 ">
                      <table width="100%" className="pdfcontent">
                        <tbody>
                          <tr>
                            <td width="100%" style={{ verticalAlign: "top" }}>
                              {documentConfig?.toData && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    marginTop: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {documentConfig?.toLabel}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "10px",
                                      lineHeight: "1.4",
                                      color: "#333",
                                    }}
                                  >
                                    <div style={{ marginBottom: "1px" }}>
                                      {documentConfig?.toData?.name}
                                    </div>
                                    <div style={{ marginBottom: "1px" }}>
                                      {documentConfig?.toData?.addressline1 &&
                                        `${documentConfig?.toData?.addressline1}, `}
                                      {documentConfig?.toData?.addressline2 &&
                                        `${documentConfig?.toData?.addressline2}, `}
                                      {documentConfig?.toData?.district &&
                                        `${documentConfig?.toData?.district}, `}
                                      {documentConfig?.toData?.state &&
                                        `${documentConfig?.toData?.state}, `}
                                      {documentConfig?.toData?.country}
                                      {documentConfig?.toData?.pincode &&
                                        ` - ${documentConfig?.toData?.pincode}`}
                                    </div>
                                    <div className="font-10">
                                      {[
                                        documentConfig?.toData?.gstnumber &&
                                          `GSTIN: ${documentConfig?.toData.gstnumber}`,
                                        documentConfig?.toData?.phone &&
                                          `Mobile: ${documentConfig?.toData.phone}`,
                                        documentConfig?.toData?.referenceid &&
                                          `Reference No: ${documentConfig?.toData.referenceid}`,
                                        documentConfig?.toData?.fssai &&
                                          `FSSAI: ${documentConfig?.toData.fssai}`,
                                        documentConfig?.toData?.cinnumber &&
                                          `CIN: ${documentConfig?.toData.cinnumber}`,
                                        documentConfig?.toData?.pannumber &&
                                          `PAN: ${documentConfig?.toData.pannumber}`,
                                      ]
                                        .filter(Boolean)
                                        .map((item, index, arr) => (
                                          <React.Fragment key={index}>
                                            <span>{item}</span>
                                            {index < arr.length - 1 && (
                                              <span style={{ margin: "0 5px" }}>
                                                |
                                              </span>
                                            )}
                                          </React.Fragment>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="col-4 pe-1 ms-auto ">
                    <div className="tm_invoice_info tm_mb20 text_end">
                      <div className="tm_invoice_info_list ">
                        <p className="tm_invoice_number tm_m0 mb-0 mt-0 font-11">
                          <b className="tm_primary_color">
                            {documentConfig?.numberLabel}{" "}
                          </b>{" "}
                          {documentConfig?.number}
                        </p>
                        <p className="tm_invoice_date tm_m0 mt-0 font-11">
                          <b className="tm_primary_color"> Date: </b>{" "}
                          {documentConfig?.Date?.date}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <table
                  className="mt-3"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      <th
                        className=""
                        style={{
                          width: "20px",
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderRight: "none",
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        {" "}
                        #{" "}
                      </th>

                      {/* Item Column: Top and Right only */}
                      <th
                        className=""
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        {" "}
                        Item{" "}
                      </th>
                      <th
                        className=""
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        {" "}
                        MRP{" "}
                      </th>

                      <th
                        className=""
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        {" "}
                        Selling Price{" "}
                      </th>
                      <th
                        className=""
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        {" "}
                        Qty{" "}
                      </th>
                      <th
                        className=""
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          //  borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        Landing Cost
                      </th>
                      <th
                        className=""
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                          "--th-color":
                            selectedTheme?.templateTheme?.foregroundColor,
                        }}
                      >
                        {" "}
                        Amount{" "}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentConfig?.items?.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            width: "5%",
                            borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            width: "45%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            paddingLeft: "5px", // Space for the title
                          }}
                        >
                          {item.title}
                        </td>
                        <td
                          style={{
                            width: "12%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // Fix for MRP alignment
                          }}
                        >
                          {item.mrp}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // Fix for Selling Price alignment
                          }}
                        >
                          {item.baseprice}
                        </td>
                        <td
                          style={{
                            width: "8%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "center",
                            paddingRight: "5px", // Fix for Qty alignment
                          }}
                        >
                          {item.quantity}
                          {(() => {
                            const unitCode = item?.isSecondaryUnit
                              ? item?.unitConfig?.secondaryUnitCode
                              : item?.unitConfig?.primaryUnitCode;
                            return unitCode || "";
                          })()}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // This ensures the Amount text doesn't touch the outer border
                          }}
                        >
                          {item.lineTotalLandingCost}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // This ensures the Amount text doesn't touch the outer border
                          }}
                        >
                          {item.lineGrandTotal}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div
                  className="row"
                  style={{
                    // Matches the table side borders
                    border: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                    borderTop: "none",
                    display: "flex",
                    margin: "0",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flex: 1, // Takes up remaining space
                      padding: "10px",
                      borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`, // Match table inner border weight
                    }}
                  >
                    <p
                      style={{
                        fontSize: "11px",
                        // fontWeight: "bold",
                        margin: "0",
                      }}
                    >
                      IN WORDS : {documentConfig?.amountInWords}
                    </p>
                    <div className="d-flex" style={{ marginTop: "20px" }}>
                      <div className="">
                        {documentConfig?.bankDetails && (
                            <>
                              <strong>Bank Details:</strong>
                                {documentConfig?.bankDetails
                                    ?.accountNo &&(
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>
                                  Account #:
                                </span>
                                {
                                  documentConfig?.bankDetails
                                    ?.accountNo
                                }
                              </div>
                              )}
                               {documentConfig?.bankDetails
                                    ?.ifsc &&(
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>IFSC:</span>
                                {
                                  documentConfig?.bankDetails
                                    ?.ifsc
                                }
                              </div>
                              )}
                                {documentConfig?.bankDetails
                                    ?.beneficiaryName &&(
                               <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Name:</span>
                                {
                                  documentConfig?.bankDetails
                                    ?.beneficiaryName
                                }
                              </div>
                              )}
                                {documentConfig?.bankDetails
                                    ?.bankName &&(
                               <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Bank Name:</span>
                                {
                                 documentConfig?.bankDetails
                                    ?.bankName
                                }
                              </div>
                              )}
                              {documentConfig?.bankDetails
                                    ?.branch &&(
                               <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Branch Name:</span>
                                {
                                 documentConfig?.bankDetails
                                    ?.branch
                                }
                              </div>
                              )}
                              {documentConfig?.upiId &&(
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>UPI ID:</span>
                                {documentConfig?.upiId}
                              </div>
                              )}{" "}
                            </>
                          )}
                      </div>
                      {qrCodeDataUrl && (
                          <div className="col-3 ms-auto d-flex align-items-center justify-content-end">
                            <img
                              src={qrCodeDataUrl}
                              alt="QR"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                  <div style={{ width: "300px", paddingRight: "2px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 10px",
                        borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                        // backgroundColor: "#f8f9fa"
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                        Total
                      </span>
                      <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                        {documentConfig?.grandTotal}
                      </span>
                    </div>

                    <div
                      style={{
                        padding: "8px 10px",
                        fontSize: "12px",
                        lineHeight: "1.6",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>Total Amount Before Tax</span>
                        <span>{documentConfig?.totalBasePrice}</span>
                      </div>

                      {isInterState ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>IGST</span>
                          <span>{documentConfig?.igstAmount}</span>
                        </div>
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>CGST</span>
                            <span>{documentConfig?.cgstAmount}</span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>SGST</span>
                            <span>{documentConfig?.sgstAmount}</span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>{" "}
                {documentConfig?.remarks ? (
                  <>
                    <div className="font-12 mt-2 fw-600 text-black mb-1">
                      Remark
                    </div>

                    <div
                      className="font-12 mb-2 p-0"
                      style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {capitalizeFirstLetter(documentConfig?.remarks)}
                    </div>
                  </>
                ) : null}
                <div className="row mt-0">
                  <div className="col-12">
                    <div className="font-12 mt-2  text-end">
                      {storeSettings?.invoiceSettings?.signature ? (
                        <img
                          src={
                            uRLs.IMAGE_URL +
                            storeSettings?.invoiceSettings?.signature
                          }
                          alt="Signature"
                          width="120"
                          style={{ marginBottom: "-5px" }}
                        />
                      ) : (
                        <div className="pt-4"></div>
                      )}
                      <div style={{ paddingTop: "5px" }}>
                        Authorised Signature
                      </div>
                    </div>
                  </div>
                </div>
                {storeSettings?.negobillBranding && (
                  <>
                    <div className="mt-5 fs-20 d-flex justify-content-left fw-bold">
                      <span>Powered By NegoBill.com</span>
                    </div>
                  </>
                )}
                <table width="100%"></table>
              </div>
            </div>
          </div>
        </div>
      ) : showBillDetails ? (
        <div className="tm_container">
          <div className="tm_invoice_wrap">
            <div className="tm_invoice tm_style1 tm_type1">
              <div className="tm_invoice_in p-2">
                <div
                  className="pdfcontent"
                  style={{
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      //  alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div style={{ flex: "1", textAlign: "left" }}>
                      {documentConfig?.image && (
                        <img
                          src={documentConfig?.image}
                          className="img-rounded logo"
                          height="30"
                          alt="Logo"
                        />
                      )}
                    </div>

                    <div
                      style={{
                        //  flex: "2",
                        textAlign: "center",
                        lineHeight: "16px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "700",
                          fontSize: "12px",
                          textTransform: "uppercase",
                        }}
                      >
                        {documentConfig?.fromData?.title}
                      </div>
                      <div className="font-10">
                        {documentConfig?.fromData?.addressline1 || ""}{" "}
                        {documentConfig?.fromData?.addressline2 || ""}{" "}
                        {documentConfig?.fromData?.district || ""}{" "}
                        {documentConfig?.fromData?.country || ""} {" "}
                        {documentConfig?.fromData?.pincode || ""}
                      </div>
                      <div style={{ fontSize: "10px" }}>
                        Ph: {documentConfig?.fromData?.phone || ""}
                            {documentConfig?.fromData?.additionalPhone && (
                              <>, {documentConfig.fromData.additionalPhone}</>
                            )}{" "}
                        {documentConfig?.fromData?.email &&
                          `| Email: ${documentConfig?.fromData?.email}`}
                      </div>
                    </div>

                    <div style={{ flex: "1", textAlign: "right" }}>
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "12px",
                          textTransform: "uppercase",
                        }}
                      >
                        {documentConfig?.title && <>{documentConfig?.title }</>}
                      </div>
                      {data?.status === "CANCELLED" && (
                        <div
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                        >
                          {data?.status}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {documentConfig?.toData && (
                    <div className="col-8 pe-1 ">
                      <table width="100%" className="pdfcontent">
                        <tbody>
                          <tr>
                            <td width="100%" style={{ verticalAlign: "top" }}>
                              {documentConfig?.toData && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    //  marginTop: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {documentConfig?.toLabel}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "10px",
                                      lineHeight: "1.4",
                                      color: "#333",
                                    }}
                                  >
                                    <div style={{ marginBottom: "1px" }}>
                                      {documentConfig?.toData?.name}
                                    </div>
                                    <div
                                      style={{ marginBottom: "1px" }}
                                      className="font-10"
                                    >
                                      {documentConfig?.toData?.addressline1 &&
                                        `${documentConfig?.toData?.addressline1}, `}
                                      {documentConfig?.toData?.addressline2 &&
                                        `${documentConfig?.toData?.addressline2}, `}
                                      {documentConfig?.toData?.district &&
                                        `${documentConfig?.toData?.district}, `}
                                      {documentConfig?.toData?.state &&
                                        `${documentConfig?.toData?.state}, `}
                                      {documentConfig?.toData?.country}
                                      {documentConfig?.toData?.pincode &&
                                        ` - ${documentConfig?.toData?.pincode}`}
                                    </div>
                                    <div className="font-10">
                                      {[
                                        documentConfig?.toData?.gstnumber &&
                                          `GSTIN: ${documentConfig?.toData.gstnumber}`,
                                        documentConfig?.toData?.phone &&
                                          `Mobile: ${documentConfig?.toData.phone}`,
                                        documentConfig?.toData?.referenceid &&
                                          `Reference No: ${documentConfig?.toData.referenceid}`,
                                        documentConfig?.toData?.fssai &&
                                          `FSSAI: ${documentConfig?.toData.fssai}`,
                                        documentConfig?.toData?.cinnumber &&
                                          `CIN: ${documentConfig?.toData.cinnumber}`,
                                        documentConfig?.toData?.pannumber &&
                                          `PAN: ${documentConfig?.toData.pannumber}`,
                                      ]
                                        .filter(Boolean)
                                        .map((item, index, arr) => (
                                          <React.Fragment key={index}>
                                            <span>{item}</span>
                                            {index < arr.length - 1 && (
                                              <span style={{ margin: "0 5px" }}>
                                                |
                                              </span>
                                            )}
                                          </React.Fragment>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="col-4 pe-1 ms-auto">
                    <div className="tm_invoice_info tm_mb20 text_end">
                      <div className="tm_invoice_info_list ">
                        <p className="tm_invoice_number tm_m0 mb-0 mt-0 font-10">
                          <b className="tm_primary_color">
                            {documentConfig.numberLabel}{" "}
                          </b>{" "}
                          {documentConfig?.number}
                        </p>
                        <p className="tm_invoice_date tm_m0 mt-0 font-10">
                          <b className="tm_primary_color"> Date: </b>{" "}
                          {documentConfig?.Date?.date}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <table
                  className="mt-3"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "20px",
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderRight: "none",
                          color: selectedTheme?.templateTheme?.foregroundColor,
                          backgroundColor:
                            selectedTheme?.templateTheme?.primaryColor,
                        }}
                      >
                        {" "}
                        #{" "}
                      </th>

                      {/* Item Column: Top and Right only */}
                      <th
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          color: selectedTheme?.templateTheme?.foregroundColor,
                          backgroundColor:
                            selectedTheme?.templateTheme?.primaryColor,
                        }}
                      >
                        {" "}
                        Item{" "}
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          color: selectedTheme?.templateTheme?.foregroundColor,
                          backgroundColor:
                            selectedTheme?.templateTheme?.primaryColor,
                        }}
                      >
                        {" "}
                        MRP{" "}
                      </th>

                      <th
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          color: selectedTheme?.templateTheme?.foregroundColor,
                          backgroundColor:
                            selectedTheme?.templateTheme?.primaryColor,
                        }}
                      >
                        {" "}
                        Selling Price{" "}
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          color: selectedTheme?.templateTheme?.foregroundColor,
                          backgroundColor:
                            selectedTheme?.templateTheme?.primaryColor,
                        }}
                      >
                        {" "}
                        Qty{" "}
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          borderTop: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          color: selectedTheme?.templateTheme?.foregroundColor,
                          backgroundColor:
                            selectedTheme?.templateTheme?.primaryColor,
                        }}
                      >
                        {" "}
                        Amount{" "}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentConfig?.items?.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            width: "5%",
                            borderLeft: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            width: "45%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            paddingLeft: "5px", // Space for the title
                          }}
                        >
                          {item.title}
                        </td>
                        <td
                          style={{
                            width: "12%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // Fix for MRP alignment
                          }}
                        >
                      {item.mrp }      
                                       </td>
                        <td
                          style={{
                            width: "15%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // Fix for Selling Price alignment
                          }}
                        >
                          {item.baseprice}
                        </td>
                        <td
                          style={{
                            width: "8%",
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "center",
                            paddingRight: "5px", // Fix for Qty alignment
                          }}
                        >
                          {item.quantity}
                          {(() => {
                            const unitCode = item?.isSecondaryUnit
                              ? item?.unitConfig?.secondaryUnitCode
                              : item?.unitConfig?.primaryUnitCode;
                            return unitCode || "";
                          })()}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            paddingRight: "5px", // This ensures the Amount text doesn't touch the outer border
                          }}
                        >
                          {item.lineGrandTotal}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div
                  className="row"
                  style={{
                    // Matches the table side borders
                    border: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                    borderTop: "none",
                    display: "flex",
                    margin: "0",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flex: 1, // Takes up remaining space
                      padding: "10px",
                      borderRight: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`, // Match table inner border weight
                    }}
                  >
                    <p
                      style={{
                        fontSize: "11px",
                        // fontWeight: "bold",
                        margin: "0",
                      }}
                    >
                      IN WORDS : {documentConfig?.amountInWords}
                    </p>
                    <div className="d-flex" style={{ marginTop: "20px" }}>
                      <div className="">
                        {documentConfig?.bankDetails  && (
                            <>
                              <strong>Bank Details:</strong>
                                {documentConfig?.bankDetails
                                    ?.accountNo &&(
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>
                                  Account #:
                                </span>
                                {
                                  documentConfig?.bankDetails
                                    ?.accountNo
                                }
                              </div>
                              )}
                               {documentConfig?.bankDetails
                                    ?.ifsc &&(
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>IFSC:</span>
                                {
                                  documentConfig?.bankDetails
                                    ?.ifsc
                                }
                              </div>
                              )}
                                {documentConfig?.bankDetails
                                    ?.beneficiaryName &&(
                               <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Name:</span>
                                {
                                  documentConfig?.bankDetails
                                    ?.beneficiaryName
                                }
                              </div>
                              )}
                                {documentConfig?.bankDetails
                                    ?.bankName &&(
                               <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Bank Name:</span>
                                {
                                 documentConfig?.bankDetails
                                    ?.bankName
                                }
                              </div>
                              )}
                              {documentConfig?.bankDetails
                                    ?.branch &&(
                               <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Branch Name:</span>
                                {
                                 documentConfig?.bankDetails
                                    ?.branch
                                }
                              </div>
                              )}
                              {documentConfig?.upiId &&(
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>UPI ID:</span>
                                {documentConfig?.upiId}
                              </div>
                              )}{" "}
                            </>
                          )}
                      </div>
                      {qrCodeDataUrl && (
                          <div className="col-3 ms-auto d-flex align-items-center justify-content-end">
                            <img
                              src={qrCodeDataUrl}
                              alt="QR"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                  <div style={{ width: "300px", paddingRight: "2px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 10px",
                        borderBottom: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                        //  backgroundColor: "#f8f9fa",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                        Total
                      </span>
                      <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                        {documentConfig?.grandTotal}
                      </span>
                    </div>
                  </div>
                </div>{" "}
                {documentConfig?.remarks ? (
                  <>
                    <div className="font-12 mt-2 fw-600 text-black mb-1">
                      Remark
                    </div>

                    <div
                      className="font-12 mb-2 p-0"
                      style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {capitalizeFirstLetter(documentConfig?.remarks)}
                    </div>
                  </>
                ) : null}
                <div className="row mt-0">
                  <div className="col-12">
                    <div className="font-12 mt-2  text-end">
                      {storeSettings?.invoiceSettings?.signature ? (
                        <img
                          src={
                            uRLs.IMAGE_URL +
                            storeSettings?.invoiceSettings?.signature
                          }
                          alt="Signature"
                          width="120"
                          style={{ marginBottom: "-5px" }}
                        />
                      ) : (
                        <div className="pt-4"></div>
                      )}
                      <div style={{ paddingTop: "5px" }}>
                        Authorised Signature
                      </div>
                    </div>
                  </div>
                </div>
                {storeSettings?.negobillBranding && (
                  <>
                    <div className="mt-5 fs-20 d-flex justify-content-left fw-bold">
                      <span>Powered By NegoBill.com</span>
                    </div>
                  </>
                )}
                <table width="100%"></table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="default-content">
          <p>No content available for this sale mode.</p>
        </div>
      )}
    </>
  );
};

export default StandardReceipt;
